module.exports = __webpack_public_path__ + "img/bg640.e2eadcae.png";